import { CustomersAppsCard } from "./CustomersAppsCard"
import { InstallationDevicesCard } from "./InstallationDevicesCard"
import { CardsContainer, Section, SectionHeader, SectionTitle } from "./styled"
import { SystemHealthCard } from "./SystemHealthCard"

export const TrendsSection = () => (
  <Section>
    <SectionHeader>
      <SectionTitle>Trends</SectionTitle>
    </SectionHeader>
    <CardsContainer>
      <InstallationDevicesCard />
      <CustomersAppsCard />
      <SystemHealthCard />
    </CardsContainer>
  </Section>
)
